const MissionPage = () => {
  return (
    <div className="container py-5">
      <h1 className="mb-4">Misija in Vizija</h1>
      
      <h3 className="mb-3">Naša misija</h3>
      <p>
        Naša misija je omogočiti enostavno, varno in učinkovito platformo za
        nakup in prodajo rabljenih izdelkov. Z Bazarc želimo spodbuditi
        krožno gospodarstvo, zmanjšati odpadke in omogočiti, da izdelki
        dobijo novo življenje v rokah novih lastnikov.
      </p>

      <h3 className="mt-5 mb-3">Naša vizija</h3>
      <p>
        Vizija Bazarc je postati vodilna spletna skupnost za trajnostno
        trgovanje v Sloveniji. Verjamemo v moč skupnosti in v odgovorno
        potrošnjo, kjer vsak izdelek šteje in vsak uporabnik prispeva
        k bolj trajnostnemu svetu.
      </p>
    </div>
  );
};

export default MissionPage;